// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-pagination[data-v-6b6645b4] {\n  margin: 30px 0;\n  text-align: right;\n}\n.el-pagination[data-v-6b6645b4]  .el-pager .active {\n  background-color: #73a7ff !important;\n}\n.el-pagination[data-v-6b6645b4]  .el-pager li:not(.active):hover {\n  color: #73a7ff;\n}", ""]);
// Exports
module.exports = exports;
